export class LeaderboardView {
  constructor(container, { onBack, onRefresh }) {
    this.container = container;
    this.onBack = onBack;
    this.onRefresh = onRefresh;

    this.element = null;
    this.contentEl = null;
    this.init();
  }

  init() {
    this.element = document.createElement('div');
    this.element.className = 'ui-view leaderboard-view hidden modal-backdrop';

    const card = document.createElement('div');
    card.className = 'card-panel';
    card.style.maxWidth = '520px';
    card.style.width = '100%';
    card.style.maxHeight = '85vh';
    card.style.display = 'flex';
    card.style.flexDirection = 'column';

    // Header
    const header = document.createElement('div');
    header.style.display = 'flex';
    header.style.alignItems = 'center';
    header.style.justifyContent = 'space-between';
    header.style.marginBottom = '16px';

    const titleBox = document.createElement('div');
    const title = document.createElement('h2');
    title.className = 'text-heading';
    title.textContent = 'LEADERBOARD';
    title.style.fontSize = '1.6rem';

    const sourceTag = document.createElement('span');
    sourceTag.className = 'text-muted';
    sourceTag.style.fontSize = '0.8rem';
    sourceTag.textContent = 'Platform: Start.ng';

    titleBox.appendChild(title);
    titleBox.appendChild(sourceTag);
    header.appendChild(titleBox);

    const refreshBtn = document.createElement('button');
    refreshBtn.className = 'btn-secondary';
    refreshBtn.style.padding = '8px 12px';
    refreshBtn.style.fontSize = '0.9rem';
    refreshBtn.textContent = '🔄 Refresh';
    refreshBtn.onclick = () => this.onRefresh();
    header.appendChild(refreshBtn);

    card.appendChild(header);

    // Scrollable Table Container
    this.contentEl = document.createElement('div');
    this.contentEl.style.flex = '1';
    this.contentEl.style.overflowY = 'auto';
    this.contentEl.style.marginBottom = '20px';
    this.contentEl.style.paddingRight = '4px';
    card.appendChild(this.contentEl);

    // Footer with Back Button
    const backBtn = document.createElement('button');
    backBtn.className = 'btn-primary';
    backBtn.style.width = '100%';
    backBtn.textContent = 'Back to Menu';
    backBtn.onclick = () => this.onBack();
    card.appendChild(backBtn);

    this.element.appendChild(card);
    this.container.appendChild(this.element);
  }

  showLoading() {
    this.contentEl.innerHTML = '';
    const loading = document.createElement('div');
    loading.style.textAlign = 'center';
    loading.style.padding = '36px 16px';
    loading.className = 'text-secondary';
    loading.textContent = 'Loading leaderboard from Start.ng...';
    this.contentEl.appendChild(loading);
  }

  showError(message) {
    this.contentEl.innerHTML = '';
    const errorBox = document.createElement('div');
    errorBox.style.textAlign = 'center';
    errorBox.style.padding = '32px 16px';

    const msg = document.createElement('p');
    msg.style.color = 'var(--color-danger)';
    msg.style.marginBottom = '16px';
    msg.textContent = message || 'Leaderboard is temporarily unavailable.';
    errorBox.appendChild(msg);

    const retry = document.createElement('button');
    retry.className = 'btn-secondary';
    retry.textContent = 'Try Again';
    retry.onclick = () => this.onRefresh();
    errorBox.appendChild(retry);

    this.contentEl.appendChild(errorBox);
  }

  setEntries(entries, currentPlayerName = '') {
    this.contentEl.innerHTML = '';

    if (!entries || entries.length === 0) {
      const empty = document.createElement('div');
      empty.style.textAlign = 'center';
      empty.style.padding = '36px 16px';
      empty.className = 'text-secondary';
      empty.textContent = 'No scores yet. Complete a run to set the first score!';
      this.contentEl.appendChild(empty);
      return;
    }

    const table = document.createElement('table');
    table.style.width = '100%';
    table.style.borderCollapse = 'collapse';

    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const isCurrentPlayer = currentPlayerName && entry.name === currentPlayerName;

      const tr = document.createElement('tr');
      tr.style.borderBottom = '1px solid rgba(255, 255, 255, 0.08)';
      tr.style.background = isCurrentPlayer ? 'rgba(66, 232, 224, 0.12)' : 'transparent';

      // Rank
      const tdRank = document.createElement('td');
      tdRank.className = 'tabular-num';
      tdRank.style.padding = '10px 8px';
      tdRank.style.fontWeight = '700';
      tdRank.style.width = '40px';
      tdRank.style.color = entry.rank === 1 ? 'var(--color-warning)' : 'var(--color-text-muted)';
      tdRank.textContent = `#${entry.rank}`;
      tr.appendChild(tdRank);

      // Name
      const tdName = document.createElement('td');
      tdName.style.padding = '10px 8px';
      tdName.style.fontWeight = isCurrentPlayer ? '700' : '500';
      tdName.style.color = isCurrentPlayer ? 'var(--color-primary)' : 'var(--color-text)';
      tdName.textContent = entry.name;
      tr.appendChild(tdName);

      // Score
      const tdScore = document.createElement('td');
      tdScore.className = 'tabular-num';
      tdScore.style.padding = '10px 8px';
      tdScore.style.textAlign = 'right';
      tdScore.style.fontWeight = '800';
      tdScore.style.color = 'var(--color-primary)';
      tdScore.textContent = String(entry.score);
      tr.appendChild(tdScore);

      table.appendChild(tr);
    }

    this.contentEl.appendChild(table);
  }

  show() {
    this.element.classList.remove('hidden');
  }

  hide() {
    this.element.classList.add('hidden');
  }
}
